import { useQuery } from '@tanstack/react-query';
import type { KpiDashboard } from '@stfors/shared-types';
import { api } from '../client';

export function useKpiDashboard() {
  return useQuery({
    queryKey: ['kpi', 'dashboard'],
    queryFn: ({ signal }) => api.get<KpiDashboard>('/api/kpi/dashboard', signal),
    // Aggregate counts move slowly — cache them for a minute so the
    // dashboard doesn't re-hit the server on every navigation.
    staleTime: 60_000,
  });
}
